module.exports = __webpack_public_path__ + "static/img/03.fada153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/03.png
// module id = weUw
// module chunks = 1